import React from 'react';
import { useStore } from '../../../../store';
import { useParams } from 'react-router-dom';
import TrainingAnimation from '../../components/TrainingAnimation';
import line from './../../../../../../assets/cybersecurity2026/welcome/line.png';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const paragraphsSettings = settings?.paragraphs[0];

  const param = useParams();
  const p_course = param.course || 'cybersecurity2026';
  const p_topic = param['*'] || 'welcome';
  const { getParagraphState, setParagraphState } = useStore();
  const paragraphs = getParagraphState(p_course, p_topic);
  const onCompleted = () => {
    paragraphs[0].state = 'completed';
    setParagraphState(p_course, p_topic, paragraphs);
  };
  return (
    <div className="topic-section-0">
      <div className="topic-section-0-left">
        <div className="title" style={{ marginBottom: 0 }}>
          {settings?.welcome}
        </div>
        <div className="title">{settings?.message}</div>
        <img className="left-img" src={line} alt="" />
        <div
          className="description"
          dangerouslySetInnerHTML={{
            __html: paragraphsSettings?.description,
          }}
        />
      </div>
      <TrainingAnimation
        onCompleted={onCompleted}
        title={paragraphsSettings?.message}
        items={[
          {
            icon: 'one',
            title: paragraphsSettings?.l1,
            content: [paragraphsSettings?.l6, paragraphsSettings?.l7],
          },
          {
            icon: 'two',
            title: paragraphsSettings?.l2,
            content: [
              paragraphsSettings?.l10,
              paragraphsSettings?.l11,
              paragraphsSettings?.l12,
            ],
          },
          {
            icon: 'three',
            title: paragraphsSettings?.l3,
            content: [
              paragraphsSettings?.l13,
              paragraphsSettings?.l14,
              paragraphsSettings?.l15,
              paragraphsSettings?.l16,
            ],
          },
          {
            icon: 'four',
            title: paragraphsSettings?.l4,
            content: [
              paragraphsSettings?.l17,
              paragraphsSettings?.l18,
              paragraphsSettings?.l19,
            ],
          },
        ]}
      />
    </div>
  );
};
export default Section1;
